import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetencyTypeForm from '../../../components/forms/CompetencyTypeForm';
import { useCompetencyTypeById, useUpdateCompetencyType } from '../../../hooks/useCompetencyTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { CompetencyTypeDTO } from '../../../services/apiClient';

const CompetencyTypeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useCompetencyTypeById(id!);
  const updateCompetencyType = useUpdateCompetencyType();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competency Types', href: '/admin/competencytypes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateCompetencyType.mutateAsync({ id: id!, data });
      navigate(-1);
    } catch (error) {
      console.error('Error updating CompetencyType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competencytypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.CompetencyType.Edit"
    >
      {entityData ? (
        <CompetencyTypeForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate(-1)}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default CompetencyTypeEdit;
